module.exports = __webpack_public_path__ + "img/autocar_preferences.116d9a33.png";